import { render, staticRenderFns } from "./FileRecord.vue?vue&type=template&id=4ad33fbd&scoped=true"
import script from "./FileRecord.vue?vue&type=script&lang=js"
export * from "./FileRecord.vue?vue&type=script&lang=js"
import style0 from "./FileRecord.vue?vue&type=style&index=0&id=4ad33fbd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad33fbd",
  null
  
)

export default component.exports